import { Box, Heading } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import FaceliftText from '@/components/Atoms/FaceliftText';
import CollectionsSummary from '@/components/Templates/CollectionsSummary';

const Collections = () => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Simulate loading state
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 2000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<Box p={{ base: 4, md: 6 }} bg={{ base: 'gray.50', _dark: 'gray.900' }}>
			{/* Page Title */}
			<FaceliftText fontWeight={600} fontSize="x-large" mb={6} ml={{ base: 0, md: 7 }}>
				Collections
			</FaceliftText>

			<CollectionsSummary isLoading={isLoading} />
		</Box>
	);
};

export default Collections;

